import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { VMediumTypeComboBoxComponent } from '../../../commons/kymw02/combo-box/vmedium-type-combo-box/vmedium-type-combo-box.component';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { KYMW6001Model } from './kymw6001.model';
import { ActivatedRoute } from '@angular/router';
import { GetCwsPlanGoodsUseImageGroupDispListService } from './api-services/get-cws-plan-goods-use-image-group-disp-list.service';
import { ImageListInfo } from './vo/image_list_info.model';
import { OrderImageListInfo } from './vo/order_image_list_info.model';
import { CommonModule } from '@angular/common';
import { GetCwsPlanGoodsUseImageGroupListService } from './api-services/get-cws-plan-goods-use-image-group-list.service';
import { KYMW5002InputModel } from 'src/app/commons/kymw50/kymw5002/vo/kymw5002-input.model';
import { KYMW5002Component } from 'src/app/commons/kymw50/kymw5002/kymw5002.component';
import { KYMW5002OutputModel } from 'src/app/commons/kymw50/kymw5002/vo/kymw5002-output.model';
import { KYMW0C00InputModel } from 'src/app/commons/kymw0c/kymw0c00/vo/kymw0c00-input.model';
import { KYMW0C00Component } from 'src/app/commons/kymw0c/kymw0c00/kymw0c00.component';
import { UpdateCheckStatusService } from './api-services/update-check-status.service';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { ImageDetailListInfo } from './vo/image_detail_list_info.model';
import { KYMW0C00OutputModel } from 'src/app/commons/kymw0c/kymw0c00/vo/kymw0c00-output.model';
import { GetImageGroupInfoService } from 'src/app/commons/kymw0c/kymw0c00/api-services/get-image-group-info.service';
import { CwsPlanGoodsUseImageGrioupListService } from '../kymw6000/list-service/cwsPlanGoodsUseImageGroupList.service';

/**
 * 各生協の注文コード欄に表示する記号
 * 使用画像指示があり、注文コードがある場合、注文コードを表示する
 * @enum
 */
export const enum DISPLAY_ORDER_NUM {
  /** 使用画像指示があり、注文コードが無い場合 */
  SELECTED_COOP_NO_ORDERNUM = "〇",
  /** 使用画像指示が無い場合 */
  NO_SELECTED_COOP = "-",
}

/**
 * 各商品のマルチ・クロス欄に表示する記号
 * @enum
 */
export const enum DISPLAY_MULTICROSS {
  /** マルチコマの場合 */
  MULTI_FLG = "M",
  /** クロスコマの場合 */
  CROSS_FLG = "C",
  /** 上記のどちらでもない場合 */
  NO_MULTI_CROSS = "-",
}

/**
 * EC使用画像一覧表画面を管理するクラス
 *
 * @export KYMW6001Component
 * @class KYMW6001Component
 */
@Component({
  selector: 'app-kymw6001',
  templateUrl: 'kymw6001.component.html',
  styleUrls: ['kymw6001.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW6001Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: VMediumTypeComboBoxComponent;

  // 親画面からの連携値
  param: any;

  kymw6001Model: KYMW6001Model = new KYMW6001Model();

  public enabled = null;

  /** 編集済みかをチェックするカウンタ */
  public editFlag: boolean = <boolean>false;

  // 生協リスト
  public readonly coopList = Object.keys(this.kymw00Model.COOP_MAP);

  /** ユーザ権限(0：使用不可、1：閲覧のみ、2：フルコントロール可能) */
  public permission: string = <string>'1';

  // 画面表示用変数
  public displayClass: string = <string>'';
  public displayMedium: string = <string>'';
  public displayFeature: string = <string>'';

  /**
   * Creates an instance of KYMW6001Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {KYMW00Model} kymw00Model
   * @param {UpdateCheckStatusService} updateCheckStatusService
   * @param {GetCwsPlanGoodsUseImageGroupDispListService} getCwsPlanGoodsUseImageGroupDispList
   * @param {GetCwsPlanGoodsUseImageGroupListService} getCwsPlanGoodsUseImageGroupListService
   * @memberof KYMW6001Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private commonModule: CommonModule,
    private activeRoute: ActivatedRoute,
    private updateCheckStatusService: UpdateCheckStatusService,
    private getCwsPlanGoodsUseImageGroupDispListService: GetCwsPlanGoodsUseImageGroupDispListService,
    private getCwsPlanGoodsUseImageGroupListService: GetCwsPlanGoodsUseImageGroupListService,
    private getImageGroupInfoService: GetImageGroupInfoService,
    private cwsPlanGoodsUseImageListService: CwsPlanGoodsUseImageGrioupListService,
  ) {
    super(kymw00Model);

    // 権限
    this.permission = this.getFuncPermission('KYMW6000');
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.activeRoute.queryParams.subscribe(params => {
      if ('orderCode' in params) {
        this.kymw6001Model.orderCode = params['orderCode'];
      }
      if ('mediumType' in params) {
        this.kymw6001Model.mediumType = params['mediumType'];
      }
      if ('mediumName' in params) {
        this.kymw6001Model.mediumName = params['mediumName'];
      }
      if ('catalogId' in params) {
        this.kymw6001Model.catalogId = params['catalogId'];
      }
      if ('classCode' in params) {
        this.kymw6001Model.classCode = params['classCode'];
      }
      if ('className' in params) {
        this.kymw6001Model.className = params['className'];
      }
      if ('pCode' in params) {
        this.kymw6001Model.pCode = params['pCode'];
      }
      if ('featureCode' in params) {
        this.kymw6001Model.featureCode = params['featureCode'];
      }
      if ('featureName' in params) {
        this.kymw6001Model.featureName = params['featureName'];
      }
      if ('multiOrCrossFlg' in params) {
        this.kymw6001Model.multiOrCrossFlg = params['multiOrCrossFlg'];
      }
      if ('imageNoUseFlag' in params) {
        this.kymw6001Model.imageNoUseFlag = params['imageNoUseFlag'];
      }
      if ('imageCheckFlag' in params) {
        this.kymw6001Model.imageCheckFlag = params['imageCheckFlag'];
      }
      this.kymw6001Model.pageNum = 1;
      this.formatDisplayValue();

    })

    // kymw6000側で一覧取得済み
    this.successGetImageGroupDispList(this.cwsPlanGoodsUseImageListService.imageList);

    this.componentName = 'KYMW6001';
    this.kymw6001Model.KYMW6001Component = this;
  }

  /**
   * 画面表示用にフォーマット
   */
  formatDisplayValue() {
    this.displayClass = PlessViewUtilsSub.toDisplayCodeAndName(this.kymw6001Model.classCode, this.kymw6001Model.className);
    this.displayFeature = PlessViewUtilsSub.toDisplayCodeAndName(this.kymw6001Model.featureCode, this.kymw6001Model.featureName);
    this.displayMedium = PlessViewUtilsSub.toDisplayCodeAndName(this.kymw6001Model.mediumType, this.kymw6001Model.mediumName);
  }

  /**
   * CWS使用画像一覧表(全体)成功後の処理
   * 
   * @param data 
   */
  private successGetImageGroupDispList(data: any): void {

    this.kymw6001Model.imageListInfo = [];

    this.kymw6001Model.pcodeInfoList = data.PCodeInfoList.map(item => ({
      pCode: item.PCode,
      coopInfoList: item.CoopInfoList.map(coop => ({
        coopCode: coop.CoopCode,
        orderNum: coop.OrderNum,
      }))
    }));

    for (const item of data.GoodsUseImageList) {
      if (this.kymw6001Model.imageListInfo.length > 0) {

        //Pコードが一致するレコードを検索
        const filteredItem = this.kymw6001Model.imageListInfo.find(v => v.pCode === item.PCode);

        //Pコードが一致するレコードが存在する場合
        if (filteredItem) {
          // 生協リスト作成
          const orderImageItem = this.createOrderImageListInfo(item);
          // 画像リスト作成
          const imageDetailList = this.createImageDetailList(item);

          orderImageItem.imageDetailListInfo = imageDetailList;

          // 画像未設定行は最後に持っていきたいため調整
          if (imageDetailList.length == 0 || filteredItem.orderImageListInfo.length == 0) {
            filteredItem.orderImageListInfo.push(orderImageItem);
          } else {
            filteredItem.orderImageListInfo.splice(
              filteredItem.orderImageListInfo.length - 1, // 挿入位置（最後の1つ前）
              0,
              orderImageItem);
          }
        } else {
          //Pコードが一致するレコードが存在しない場合
          const addItem = this.createImageListInfo(item);
          // 生協リスト作成
          const orderImageItem = this.createOrderImageListInfo(item);
          // 画像リスト作成
          const imageDetailList = this.createImageDetailList(item);
          // 生協情報（画像情報込）作成
          orderImageItem.imageDetailListInfo = imageDetailList;

          addItem.orderImageListInfo.push(orderImageItem);

          this.kymw6001Model.imageListInfo.push(addItem);
        }
      } else {
        // Pコードから追加する
        const addItem = this.createImageListInfo(item);
        // 生協リスト作成
        const orderImageItem = this.createOrderImageListInfo(item);
        // 画像リスト作成
        const imageDetailList = this.createImageDetailList(item);
        // 生協情報（画像情報込）作成
        orderImageItem.imageDetailListInfo = imageDetailList;

        addItem.orderImageListInfo.push(orderImageItem);

        this.kymw6001Model.imageListInfo.push(addItem);
      }
    }

    this.kymw6001Model.imageListInfo.forEach((imageList, ind) => {
      let imageChk = false;
      const imageChkList = []
      imageList.orderImageListInfo.forEach(orderImageList => {
        orderImageList.imageDetailListInfo.forEach(imageItem => {
          if (imageItem.ImageCheckFlag == "1") {
            imageChkList.push(true)
          } else {
            imageChkList.push(false)
          }
        });
      });
      if (imageChkList.length > 0 && !imageChkList.includes(false)) {
        imageChk = true;
      }
      this.kymw6001Model.imageListInfo[ind].imageChk = imageChk;
      this.kymw6001Model.imageListInfo[ind].imageChkDisabledFlg = imageChk;
    });

    this.kymw6001Model.totalNum = data.TotalNum;
    this.kymw6001Model.startDispNum = Number(data.StartDispNum);
    this.kymw6001Model.endDispNum = data.EndDispNum;
  }

  /**
   * 注文情報、画像情報の作成
   * 
   * @param serverData 
   * @returns 
   */
  private createOrderImageListInfo(serverData: any) {
    // 生協リスト
    const orderImageItem = new OrderImageListInfo();
    this.coopList.forEach(coopItem => {
      // 注文コード
      orderImageItem[`orderNum${coopItem}`] = serverData[`OrderNum${coopItem}`];
      // 表示用注文コード
      orderImageItem[`displayOrderNum${coopItem}`] =
        this.getOrderNum(serverData[`OrderNum${coopItem}`], serverData[`CoopFlg${coopItem}`]);
      // 取扱生協
      orderImageItem[`coopFlg${coopItem}`] = serverData[`CoopFlg${coopItem}`];
    })

    return orderImageItem;
  }

  /**
   * 画像詳細情報の作成
   * 
   * @param serverData 
   * @returns 
   */
  private createImageDetailList(serverData: any) {

    // 画像リスト
    const imageDetailList = [];
    serverData.ImageList.forEach(imageItem => {
      const imageDetailItem = new ImageDetailListInfo();
      imageDetailItem.showSeq = imageItem.ShowSeq;
      imageDetailItem.imageFileId = imageItem.ImageId;
      imageDetailItem.fileImagePath = imageItem.FileImagePath;
      imageDetailItem.imageFileName = imageItem.ImageFileName;
      imageDetailItem.cookingExPublish = imageItem.CookingExPublish;
      imageDetailItem.ImageCheckFlag = imageItem.ImageCheckFlag;
      imageDetailItem.imageName = imageItem.ImageName;
      imageDetailItem.startOrderCodeImageId = imageItem.StartOrderCodeImageId;
      imageDetailItem.textCaption = imageItem.TextCaption;
      imageDetailItem.cookingExPublish = imageItem.CookingExPublish;
      imageDetailList.push(imageDetailItem);
    })

    return imageDetailList;
  }

  /**
   * 画像情報一覧の作成
   * 
   * @param serverData 
   * @returns 
   */
  private createImageListInfo(serverData: any) {
    const addItem = new ImageListInfo();
    addItem.pCode = serverData.PCode;
    addItem.classCode = serverData.ClassCode;
    addItem.classNameKanji = serverData.ClassNameKanji;
    addItem.guideGoodsName = serverData.GoodsName;
    addItem.guideStandardName = serverData.GoodsStandardName;
    addItem.multiOrCrossFlg = this.getMultiOrCross(serverData);

    return addItem;
  }

  /**
   * マルチ・クロス変換処理
   * 
   * @param item 
   * @returns 
   */
  private getMultiOrCross(item: any): string {
    if (item.SkuFlg == "1" && item.CrossFlg == "1") {
      return DISPLAY_MULTICROSS.MULTI_FLG + "・" + DISPLAY_MULTICROSS.CROSS_FLG;
    } else if (item.SkuFlg == "0" && item.CrossFlg == "0") {
      return DISPLAY_MULTICROSS.NO_MULTI_CROSS;
    } else if (item.SkuFlg == "1" && item.CrossFlg == "0") {
      return DISPLAY_MULTICROSS.MULTI_FLG;
    } else if (item.SkuFlg == "0" && item.CrossFlg == "1") {
      return DISPLAY_MULTICROSS.CROSS_FLG;
    }
  }

  /**
   * 注文番号変換処理
   * 
   */
  public getOrderNum(orderNum: string, orderFlg: string): string {
    if (orderFlg == '0') {
      return DISPLAY_ORDER_NUM.NO_SELECTED_COOP;
    } else if (!PlessViewUtilsSub.isEmpty(orderNum)) {
      return orderNum;
    } else {
      return DISPLAY_ORDER_NUM.SELECTED_COOP_NO_ORDERNUM;
    }
  }

  /**
   * 一覧出力ボタンを押下した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventOutput_CLICKHandler(): void {
    const vo = {
      /** 受注コード */
      orderCode: '',
      /** 媒体区分 */
      mediumType: '',
      /** 配達企画回（翌週） */
      catalogId: '',
      /** 部門コード */
      classCode: '',
      /** Pコード */
      pCode: '',
      /** 特集コード */
      featureCode: '',
      /** マルチ・クロスフラグ */
      multiOrCrossFlg: '',
      /** 画像未指定 */
      imageNoUseFlag: '',
      /** 確認状況 */
      imageCheckFlag: ''
    };

    // VO設定
    vo.orderCode = this.kymw6001Model.orderCode;
    vo.mediumType = PlessViewUtilsSub.nullToBlank(this.kymw6001Model.mediumType);
    vo.catalogId = this.kymw6001Model.catalogId;
    vo.classCode = PlessViewUtilsSub.nullToBlank(this.kymw6001Model.classCode);
    vo.pCode = PlessViewUtilsSub.nullToBlank(this.kymw6001Model.pCode);
    vo.featureCode = PlessViewUtilsSub.nullToBlank(this.kymw6001Model.featureCode);
    vo.multiOrCrossFlg = PlessViewUtilsSub.nullToBlank(this.kymw6001Model.multiOrCrossFlg);
    vo.imageNoUseFlag = PlessViewUtilsSub.nullToBlank(this.kymw6001Model.imageNoUseFlag);
    vo.imageCheckFlag = PlessViewUtilsSub.nullToBlank(this.kymw6001Model.imageCheckFlag);

    // API呼び出し
    this.getCwsPlanGoodsUseImageGroupListService.execute(this.kymw6001Model, vo, (data: any) => {
      // ファイル名の設定
      const fileName =
        this.kymw6001Model.orderCode + "_" +
        (!PlessViewUtilsSub.isEmpty(this.kymw6001Model.mediumType) ? this.kymw6001Model.mediumType : "ALL") + "_" +
        PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.pdf';
      this.fileDownloadConfirmService.show(data.FileName, fileName);
    });
  }

  /**
   * 新規画像登録ボタンを押下した時に呼び出されるメソッド。
   *
   */
  public eventImageAdd_CLICKHandler(item: ImageListInfo, imageItem: OrderImageListInfo, ind: number, imageInd: number): void {
    const kymw0C00InputVO: KYMW0C00InputModel = new KYMW0C00InputModel();
    // 画像作成画面を起動
    const componentRef = this.dialogService.openModal(KYMW0C00Component);
    const instance = componentRef.componentInstance as KYMW0C00Component;
    instance.parent = this;
    instance.setInterfaceParam(kymw0C00InputVO);
    instance.setKYMW0C00Parameter = (outputVO: KYMW0C00OutputModel) => {
      this.kymw6001Model.imageListInfo[ind].editFlg = true;
      this.editFlag = true;

      // 変更行情報の定義
      const updateLine = this.kymw6001Model.imageListInfo[ind].orderImageListInfo[imageInd];

      let seq = updateLine.imageDetailListInfo.length; // 画像シーケンス番号
      const processedImageIdList: Array<string> = []; // 処理済み画像ID格納リスト

      // KYMW0C00で登録された画像毎にループ
      for (const image of outputVO.ImageList) {

        // 画像グループ情報取得
        this.getImageGroupInfoService.execute(this.kymw6001Model, image.ImageId, (data: any) => {

          // グループ内の画像毎にループ
          for (const imageInfo of data.ImageInfoList) {

            // 登録後にKYMW0C00側でAPI発行をした際にも当コールバックが実行されているため、
            // 二重表示にならないように処理済の画像の場合は処理をスキップする。
            if (processedImageIdList.includes(imageInfo.ImageID)) {
              continue;
            }

            // 変更行の画像詳細リストに追加
            const addItem = new ImageDetailListInfo();
            addItem.ImageCheckFlag = "0";
            addItem.fileImagePath = imageInfo.ImagePreviewUrl1;
            addItem.imageFileId = imageInfo.ImageID;
            addItem.imageFileName = imageInfo.ImageFileName;
            addItem.showSeq = String(++seq);
            addItem.imageInstructFlag = true;
            addItem.imageName = imageInfo.ImageName;
            addItem.startOrderCodeImageId = data.StartOrderCode;
            addItem.textCaption = imageInfo.TextCaption;
            addItem.cookingExPublish = imageInfo.CookingExPublish;
            updateLine.imageDetailListInfo.push(addItem);

            processedImageIdList.push(imageInfo.ImageID);
          }
        });
      }

      // 確認済のチェックを外す
      this.kymw6001Model.imageListInfo[ind].imageChk = false;
      this.kymw6001Model.imageListInfo[ind].imageChkDisabledFlg = false;
      // 串刺のチェックを外す
      this.kymw6001Model.imageListInfo[ind].orderImageListInfo[imageInd].skewerSelect = false;
    }
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 商品画像変更ボタンを押下した時に呼び出されるメソッド。
   *
   * @param item        商品情報        （Pコード行）
   * @param updateLine  使用画像指示情報（Pコード行内の使用画像指示行）
   * @param ind         商品（Pコード）行のインデックス
   * @param imageInd    使用画像指示情報行のインデックス
   */
  public eventImageUpdate_CLICKHandler(item: ImageListInfo, updateLine: OrderImageListInfo, ind: number, imageInd: number): void {
    const componentRef = this.dialogService.openModal(KYMW5002Component);
    const instance = componentRef.componentInstance as KYMW5002Component;
    instance.parent = this;
    const kymw5002InputVO = this.setKYMW5002InputModel(item, updateLine);
    instance.setInterfaceParam(kymw5002InputVO);
    instance.setKYMW5002Parameter = (outputVO: KYMW5002OutputModel) => {

      item.editFlg = true;
      this.editFlag = true;

      const pCodeInfo = this.kymw6001Model.pcodeInfoList.find(_ => _.pCode === item.pCode);

      // --- 処理の流れ ---
      // 1. 画像指示・生協選択の変化確認　
      // 2. 選択された生協の画像指示データを削除
      // 3. 選択された生協データの作成・一覧に追加
      // 4. 画像指示の画像IDと順番が同じものがあれば行をマージする
      // 5. 取扱生協で選択されていない生協があれば空行にいれる
      // -----------------

      // 全生協未選択の場合なにもしない
      if (PlessViewUtilsSub.isEmptyArray(outputVO.selectCoopInfoVOList)) return;

      // 画像変更もしくは順番変更されている？
      let isChangeImage = false;
      if (updateLine.imageDetailListInfo.length != outputVO.useImageInfoVOList.length) {
        isChangeImage = true;
      } else {
        for (let i = 0; i < updateLine.imageDetailListInfo.length; i++) {
          // 配列のlengthが同じなのは上のifで確認済み
          if (updateLine.imageDetailListInfo[i].imageFileId != outputVO.useImageInfoVOList[i].ImageId
            || updateLine.imageDetailListInfo[i].textCaption != outputVO.useImageInfoVOList[i].TextCaption
          ) {
            isChangeImage = true;
            break;
          }
        }
      }

      // 選択生協が変わっているか？
      const beforeSelectCoopSet = new Set(kymw5002InputVO.selectCoopInfoVOList.map(_ => _.selectCoopCode));
      let isChangeCoop = false;
      if (beforeSelectCoopSet.size != outputVO.selectCoopInfoVOList.length) {
        isChangeCoop = true;
      } else {
        if (!outputVO.selectCoopInfoVOList.every(_ => beforeSelectCoopSet.has(_.selectCoopCode))) {
          isChangeCoop = true;
        }
      }

      // 画像も生協も変わっていない場合、何もしない
      if (!isChangeImage && !isChangeCoop) return;

      // 一旦選択された生協データを削除
      outputVO.selectCoopInfoVOList.forEach(coop => {
        item.orderImageListInfo.forEach(imageInfo => {
          if (imageInfo[`coopFlg${coop.selectCoopCode}`] == "1") {
            imageInfo[`coopFlg${coop.selectCoopCode}`] = "0";
            imageInfo[`displayOrderNum${coop.selectCoopCode}`] = DISPLAY_ORDER_NUM.NO_SELECTED_COOP;
          }
        })
      })
      this.coopList.forEach(coop => {
        updateLine[`orderNum${coop}`] = pCodeInfo.coopInfoList.find(_ => _.coopCode == coop)?.orderNum ?? '';
      });

      // 選択された生協のデータを作成
      const newImageInfo = new OrderImageListInfo();
      const imageDetailList = [];
      outputVO.useImageInfoVOList.forEach(outputImage => {
        const imageDetailItem = new ImageDetailListInfo();
        imageDetailItem.showSeq = outputImage.ShowSeq;
        imageDetailItem.imageFileId = outputImage.ImageId;
        imageDetailItem.fileImagePath = outputImage.ImageURL;
        imageDetailItem.imageFileName = outputImage.ImageFileName;
        imageDetailItem.ImageCheckFlag = "0";
        imageDetailItem.imageName = outputImage.ImageName;
        imageDetailItem.startOrderCodeImageId = outputImage.StartOrderCode;
        imageDetailItem.textCaption = outputImage.TextCaption;
        imageDetailItem.cookingExPublish = outputImage.CookingExPublish;
        imageDetailList.push(imageDetailItem);
      });
      newImageInfo.imageDetailListInfo = imageDetailList;

      outputVO.selectCoopInfoVOList.forEach(coopInfo => {
        newImageInfo[`coopFlg${coopInfo.selectCoopCode}`] = "1";
        newImageInfo[`orderNum${coopInfo.selectCoopCode}`] = updateLine[`orderNum${coopInfo.selectCoopCode}`];
        newImageInfo[`displayOrderNum${coopInfo.selectCoopCode}`] = this.getOrderNum(newImageInfo[`orderNum${coopInfo.selectCoopCode}`], newImageInfo[`coopFlg${coopInfo.selectCoopCode}`]);
        newImageInfo[`skewerSelect`] = updateLine[`skewerSelect`];
      });
      // 画像変更ボタンを押した場所に挿入
      item.orderImageListInfo.splice(imageInd, 0, newImageInfo);

      // 画像指示が同じデータがあるか？
      for (let i = 0; i < item.orderImageListInfo.length; i++) {
        // 自身はチェックしない
        if (i === imageInd) continue;

        let targetRow = item.orderImageListInfo[i];
        let isDataSearched = true;
        // 画像数が同じかチェック
        if (targetRow.imageDetailListInfo.length === outputVO.useImageInfoVOList.length) {
          for (let j = 0; j < targetRow.imageDetailListInfo.length; j++) {
            if (targetRow.imageDetailListInfo[j].imageFileId != outputVO.useImageInfoVOList[j].ImageId) {
              // 画像が同じかチェック、違う場合はbreak;
              isDataSearched = false;
              break;
            }
          }

          if (isDataSearched) {
            // KYMW5002の上部の画像キャプションが変更されている場合、変更後を適用する
            targetRow.imageDetailListInfo.forEach(targetImage => {
              const newTextCaption = outputVO.useImageInfoVOList.find(_ => _.ImageId == targetImage.imageFileId)?.TextCaption;
              if (targetImage.textCaption != newTextCaption) targetImage.textCaption = newTextCaption;
            });

            //同じデータあり、マージ
            //画像は同じなので生協の調整をすればよい
            outputVO.selectCoopInfoVOList.forEach(coop => {
              targetRow[`coopFlg${coop.selectCoopCode}`] = "1";
              targetRow[`orderNum${coop.selectCoopCode}`] = pCodeInfo.coopInfoList.find(_ => _.coopCode == coop.selectCoopCode).orderNum;
              targetRow[`displayOrderNum${coop.selectCoopCode}`] = this.getOrderNum(targetRow[`orderNum${coop.selectCoopCode}`], targetRow[`coopFlg${coop.selectCoopCode}`]);
              targetRow[`skewerSelect`] = updateLine[`skewerSelect`];
            });
            // 自行を削除
            item.orderImageListInfo =
              item.orderImageListInfo.filter((_, k) => k !== imageInd);

            break;
          }
        }
      }

      // 串刺チェック状況を保持
      // ※下記の「一旦空行を削除」する処理で、空行の串刺チェック状況がクリアされてしまうため。
      // 同じPコードで複数行あるとき、もう一方の串刺チェックに影響が出てしまったので、串刺状況を保持しておくこととした。
      // モーダルを閉じる際に画像変更をした行の「串刺」はチェックOFFとし、それ以外は前の状況と同じになるような処理としている。
      const skewerSelectList = item.orderImageListInfo.map(orderImage => {
        // 対象生協リスト
        const coopList = this.coopList.filter(coop => orderImage[`coopFlg${coop}`] == "1");
        // 串刺状況、Pコード、対象生協リスト
        return {
          skewerSelect: orderImage.skewerSelect,
          pCode: item.pCode,
          coopList: coopList
        }
      })

      // 一旦空行を削除
      item.orderImageListInfo =
        item.orderImageListInfo.filter(item => {
          return item.imageDetailListInfo.length !== 0;
        });
      // 全生協未選択の行を削除
      item.orderImageListInfo =
        item.orderImageListInfo.filter(item =>
          !pCodeInfo.coopInfoList.every(coop => item[`coopFlg${coop.coopCode}`] == "0")
        );

      // 取扱生協のある生協コードのみを保持
      const enableCoopSet = new Set(pCodeInfo.coopInfoList.map(_ => _.coopCode));
      // ここまでで使われていない生協があるか探索
      let unusedCoopList = [...this.coopList].filter(coop => enableCoopSet.has(coop));
      this.coopList.forEach(coopCode => {
        item.orderImageListInfo.forEach(checkItem => {
          if (checkItem[`coopFlg${coopCode}`] === "1") {
            unusedCoopList = unusedCoopList.filter(v => v !== coopCode);
          }
        });
      });
      // あったら空行を追加、ない場合は空行を追加しない
      if (unusedCoopList.length > 0) {
        const emptyOrderImageItem = new OrderImageListInfo();
        this.coopList.forEach(coopCode => {
          emptyOrderImageItem[`orderNum${coopCode}`] = pCodeInfo.coopInfoList.find(_ => _.coopCode == coopCode)?.orderNum ?? '';
        })
        unusedCoopList.forEach(coopCode => {
          emptyOrderImageItem[`coopFlg${coopCode}`] = "1";
          emptyOrderImageItem[`displayOrderNum${coopCode}`] = this.getOrderNum(emptyOrderImageItem[`orderNum${coopCode}`], emptyOrderImageItem[`coopFlg${coopCode}`]);
        });
        item.orderImageListInfo.push(emptyOrderImageItem);
      }

      // 確認チェックボックスをクリア
      item.imageChk = false;
      item.imageChkDisabledFlg = false;

      // 変更前の全ての行の串刺状況を反映させる
      // （「一旦空行を削除」する処理で、空行の串刺チェック状況がクリアされてしまったため、一度全ての行に反映させる）
      item.orderImageListInfo.map(orderImage => {
        // 対象生協をリストで取得
        const coopList = this.coopList.filter(coopCode => orderImage[`coopFlg${coopCode}`] == "1");
        // Pコードと生協リストが一致するデータに対して串刺状況を反映
        orderImage[`skewerSelect`] = skewerSelectList.find(s => s.pCode === pCodeInfo?.pCode && coopList.every(_ => s.coopList.includes((_)))).skewerSelect;
      })
      // 画像変更した行の串刺チェックボックスをクリア
      item.orderImageListInfo[imageInd].skewerSelect = false;
    }
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * EC画像指示ダイアログパラメータ設定
   * 
   * @param item 
   * @param imageItem 
   * @returns 
   */
  private setKYMW5002InputModel(item: ImageListInfo, imageItem: OrderImageListInfo) {
    const selectCoopInfoVOList = [];
    const enableCoopCodeVOList = [];

    // 生協の活性制御と初期チェックを設定
    const pcodeInfo = this.kymw6001Model.pcodeInfoList.find(_ => _.pCode === item.pCode);
    this.coopList.forEach(coop => {
      if (imageItem[`coopFlg${coop}`] == "1") {
        selectCoopInfoVOList.push({ 'selectCoopCode': coop })
      }
      if (pcodeInfo.coopInfoList.find(_ => _.coopCode === coop)) {
        enableCoopCodeVOList.push({ 'enableCoopCode': coop })
      }
    });
    const useImageInfoVOList = [];
    imageItem.imageDetailListInfo.forEach(element => {
      const addItem = {
        ImageFileName: element.imageFileName,
        ImageId: element.imageFileId,
        ImageName: element.imageName,
        ImageURL: element.fileImagePath,
        ShowSeq: element.showSeq,
        StartOrderCode: element.startOrderCodeImageId,
        TextCaption: element.textCaption,
        CookingExPublish: element.cookingExPublish,
      }
      useImageInfoVOList.push(addItem);
    });
    const vo: KYMW5002InputModel = {
      flg: '3',
      orderCode: this.kymw6001Model.orderCode,
      pcode: item.pCode,
      goodsName: item.guideGoodsName,
      goodsStandardName: item.guideStandardName,
      enableCoopCodeVOList: enableCoopCodeVOList,
      selectCoopInfoVOList: selectCoopInfoVOList,
      useImageInfoVOList: useImageInfoVOList,
    } as KYMW5002InputModel;

    return vo;
  }

  /**
   * 更新ボタン押下時処理
   */
  public eventUpdate_CLICKHandler(): void {
    let updateFlg = false;
    // 編集データが存在しなければエラーメッセージを表示する
    for (const item of this.kymw6001Model.imageListInfo) {
      if (item.editFlg) {
        updateFlg = true;
        break;
      }
    }
    // 編集データダイアログ表示、編集データが存在していれば更新処理
    if (!updateFlg) {
      this.dialogService.openAlertGetMessage('E0162', ['']);
    } else {
      this.dialogService.openAlertGetMessage('Q0108', ['商品画像情報'], (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          this.updateCheckStatusService.execute(this.kymw6001Model, () => {
            // 一旦再検索をせず表示ページをそのままにし、確認チェックを非活性にする
            this.kymw6001Model.imageListInfo.forEach(item => {
              item.editFlg = false;
              if (!item.beforeUpdateImageChk && item.imageChk) {
                item.imageChkDisabledFlg = true;
              }
              // 串刺チェックボックスを全てクリアする
              item.orderImageListInfo.map(orderImage => {
                orderImage.skewerSelect = false;
              })
            });
            //編集済を解除
            this.editFlag = false;
            // 再検索
            this.getCwsPlanGoodsUseImageGroupDispListService.execute(this.kymw6001Model, (data: any) => {
              this.successGetImageGroupDispList(data);
            });
          });
        }
      });
    }
  }

  /**
   * 前へ／次へ(ボタン)_クリック時に呼び出される
   *
   * @param {number} [focusFlg=0] フォーカスフラグ(1：前へボタン、2：次へボタン)
   */
  public eventDisplaySelectedList_CLICKHandler(focusFlg = 0): void {
    if (this.editFlag) {
      this.dialogService.openAlertGetMessage(
        'Q0110', [],
        (closeDetail: any): void => {
          if (closeDetail === PlessAlert.Yes) {

            //編集済を解除
            this.editFlag = false;

            // フォーカスフラグのチェック
            switch (focusFlg) {
              case 1:
                // 「1：前へボタン」の場合  
                this.kymw6001Model.pageNum = this.kymw6001Model.pageNum - 1;
                break;
              case 2:
                // 「2：次へボタン」の場合  
                this.kymw6001Model.pageNum = this.kymw6001Model.pageNum + 1;
                break;
              default:
                return;
            }

            this.getCwsPlanGoodsUseImageGroupDispListService.execute(this.kymw6001Model, (data: any) => {
              this.successGetImageGroupDispList(data);
            });
          }
        });
    } else {
      // フォーカスフラグのチェック
      switch (focusFlg) {
        case 1:
          // 「1：前へボタン」の場合  
          this.kymw6001Model.pageNum = this.kymw6001Model.pageNum - 1;
          break;
        case 2:
          // 「2：次へボタン」の場合  
          this.kymw6001Model.pageNum = this.kymw6001Model.pageNum + 1;
          break;
        default:
          return;
      }

      this.getCwsPlanGoodsUseImageGroupDispListService.execute(this.kymw6001Model, (data: any) => {
        this.successGetImageGroupDispList(data);
      });
    }
  }

  /**
   * 「確認」のチェックボックス押下時の処理
   * @param item 対象行
   */
  public eventCheckBox_CLICKHandler(item: any): void {
    // 「確認」のチェックの変更のみでも更新が可能
    item.editFlg = true;
    this.editFlag = true;
  }

  /**
   * 「串刺」のチェックボックス押下時の処理
   */
  public eventSkewerSelect_CLICKHandler(item: any): void {
    // 「串刺」のチェックの変更のみでも更新が可能
    item.editFlg = true;
    this.editFlag = true;
  }

}
